exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-header__dense {\r\n  border: 2px solid lightgrey;\r\n  border-radius: 6px;\n}\n.filter-header__dense label {\r\n  color: black;\r\n  white-space: nowrap;\r\n  padding: 10px;\n}\n.header-name-display {\r\n  margin-bottom: 36px;\r\n  display: flex;\r\n  align-items: center;\n}\n.header-text-display {\r\n  white-space: pre-wrap;\n}\n.single-icon .header-text-display {\r\n  padding-right: 4px;\n}\n.header-text-display > .v-icon {\r\n  padding-top: 10px;\n}\r\n", ""]);

// exports
